import type { Namespace } from 'i18next';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { CON_NAME } from '@/lib/constants.ts';
import type TranslationKey from '@/lib/i18n/TranslationKey.ts';

const formatTitle = (title: string | string[]) =>
  `${Array.isArray(title) ? title.join(' | ') : title} | Furality ${CON_NAME} | F.O.X.`;

const useTitle = <NS extends Namespace & ['common', ...unknown[]] = ['common']>(
  title?: TranslationKey<NS>,
  sub?: string | string[],
  ns?: NS,
) => {
  const namespaces = ns ?? ['common'];
  // @ts-expect-error common is always included
  const { t } = useTranslation<NS>(namespaces);

  useEffect(() => {
    if (title) {
      document.title = formatTitle(
        sub ? (Array.isArray(sub) ? [...sub, t(title)] : [sub, t(title)]) : [t(title)],
      );
    }
  }, [sub, title, t]);
};

export default useTitle;
